
import { logger } from '@/lib/logger';

/**
 * Validates a password against security requirements
 */
export const validatePassword = (password: string): boolean => {
  // Password must be at least 8 characters and include a number and special character
  const hasMinLength = password.length >= 8;
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  
  return hasMinLength && hasNumber && hasSpecialChar;
};

/**
 * Validates signup form input
 */
export const validateSignupForm = (
  email: string, 
  password: string, 
  confirmPassword: string,
  fullName: string
): { isValid: boolean; errorMessage: string | null } => {
  if (!email || !password || !fullName) {
    return { isValid: false, errorMessage: "All fields are required" };
  }

  if (password !== confirmPassword) {
    return { isValid: false, errorMessage: "Passwords do not match" };
  }

  if (!validatePassword(password)) {
    return { 
      isValid: false, 
      errorMessage: "Password must be at least 8 characters and include a number and special character" 
    };
  }

  return { isValid: true, errorMessage: null };
};

/**
 * Handles throttling of signup attempts to prevent abuse
 */
export const createThrottleManager = (setIsThrottled: (value: boolean) => void) => {
  return () => {
    setIsThrottled(true);
    
    // Reset throttle after 30 seconds
    setTimeout(() => {
      setIsThrottled(false);
    }, 30000);
    
    return true;
  };
};

/**
 * Logs signup-related errors
 */
export const logSignupError = (error: any, email: string) => {
  logger.error({
    message: "Signup error",
    error: error instanceof Error ? error : new Error(String(error)),
    context: { email }
  });
};

/**
 * Logs successful signup
 */
export const logSignupSuccess = (email: string) => {
  logger.info({
    message: "User successfully signed up",
    context: { email }
  });
};
